import React, { useRef, useState } from "react";
import "./Add_Reviews.css";
import { Button, Form, Modal } from "react-bootstrap";
import Dark_Gray_Btn from "../common_btn/dark_gray_btn/Dark_Gray_Btn";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import Logo_modal from "../logo_modal/Logo_modal";
import { useForm } from "react-hook-form";
import { productReviewPost } from "../../../utils/apis/Product/Product";
import { productReviewPostLuxury } from "../../../utils/luxuryapis/Product/Product";

function Add_Reviews({ ...props }) {
  const [modalShow, setModalShow] = React.useState(false);
  const fileInputRef = useRef(null);

  const [reviewText, setReviewText] = useState("");
  const [videoFile, setVideoFile] = useState(null);
  const [videoPreview, setVideoPreview] = useState(null);

  // ✅ Open File Manager
  const handleUploadClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  // ✅ On File Select
  const handleVideoChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      setVideoFile(file);

      // Preview URL
      const previewUrl = URL.createObjectURL(file);
      setVideoPreview(previewUrl);
    }
  };

  // ✅ Remove Selected File
  const handleRemoveVideo = () => {
    setVideoFile(null);
    setVideoPreview(null);

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  // const handleSubmit = (e) => {
  //   e.preventDefault();

  //   console.log("Review Text:", reviewText);
  //   console.log("Video File:", videoFile);

  //   // setModalShow(true); // open success modal
  //   // props.onHide(); // close Add Review modal
  // };

  const {
    control,
    register,
    handleSubmit,
    getValues,
    setError,
    setValue,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
  } = useForm({
    defaultValues: {
      ratings: 1,
    },
  });

  const [selectedFiles, setSelectedFiles] = useState([]);
  const onSubmit = async (data) => {
    const sendData = new FormData();
    sendData.append("ratings", props?.rating);
    sendData.append("order_detail_id", props?.order_id);
    sendData.append("review_message", data?.review_message);
    sendData.append("product_id", props.product_id);

    if (selectedFiles.length > 0) {
      selectedFiles?.map((image, index) => {
        sendData.append(`images[${index}]`, image);
      });
    }
    const res = await productReviewPostLuxury(sendData);
    if (res?.success) {
      setModalShow(true);
      props.onHide();
      props.orderGet();
    }
  };
  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);
    setSelectedFiles([...selectedFiles, ...files]);
  };
  const handleimageClick = (event) => {
    event.preventDefault();
    fileInputRef.current.click();
  };
  const handleRemoveImage = (index) => {
    const filteredFiles = selectedFiles.filter((_, i) => i !== index);
    setSelectedFiles(filteredFiles);
  };

  console.log(props.rating, "rating rating");

  return (
    <>
      <Modal {...props} centered className="add_reviews_modal">
        <Modal.Body className="add_reviews_modal_body p-0">
          <div className="add_reviews_box">
            {/* HEADER */}
            <div className="add_reviews_header">
              <h4>Add Review</h4>
            </div>

            {/* CONTENT */}
            <div className="add_reviews_content">
              <Form onSubmit={handleSubmit(onSubmit)}>
                {/* TEXTAREA */}
                <div className="add_reviews_input_box">
                  {/* <Form.Control
                    as="textarea"
                    rows={4}
                    placeholder="Type your product review here in max. 50 characters"
                    maxLength={50}
                    value={reviewText}
                    onChange={(e) => setReviewText(e.target.value)}
                  /> */}

                  <Form.Control
                    as="textarea"
                    name="review_message"
                    type="text"
                    rows={3}
                    placeholder="Enter Message"
                    {...register("review_message", {
                      required: "Message required",
                    })}
                  />
                </div>

                {/* UPLOAD SECTION */}
                <div className="add_reviews_upload_section">
                  {/* PREVIEW (LEFT) */}
                  {/* {videoPreview && (
                    <div className="add_reviews_preview_box">
                      <Button
                        type="button"
                        className="remove_preview_btn"
                        // onClick={handleRemoveVideo}
                        onClick={handleimageClick}
                      >
                        <FontAwesomeIcon icon={faXmark} />
                      </Button>

                      <video
                        src={videoPreview}
                        className="preview_video"
                        controls={false}
                        muted
                      />
                    </div>
                  )} */}

                  {selectedFiles.length > 0 &&
                    selectedFiles.map((file, index) => (
                      <div className="file-img-holder" key={index}>
                        <object
                          className="img-logo"
                          data={URL.createObjectURL(file)}
                          type={file.type}
                          width="60" // Set the width
                          height="60" // Set the height
                        />
                        <div
                          className="cross-overlay"
                          onClick={() => handleRemoveImage(index)}
                        >
                          <img
                            className="img-cross"
                            src={
                              process.env.PUBLIC_URL +
                              "/assest/image/Careers/crossIcon.png"
                            }
                            alt={`Cross Icon ${index + 1}`}
                          />
                        </div>
                      </div>
                    ))}

                  {/* UPLOAD BOX */}
                  <div
                    className="add_reviews_upload_box"
                    onClick={handleUploadClick}
                  >
                    {/* Hidden Input */}
                    {/* <Form.Control
                      ref={fileInputRef}
                      type="file"
                      accept="video/*"
                      onChange={handleVideoChange}
                      className="hidden_file_input"
                    /> */}

                    <Form.Control
                      ref={fileInputRef}
                      type="file"
                      onChange={handleFileChange}
                      multiple
                      accept="image/*,video/*"
                      style={{ display: "none" }}
                    />

                    <div className="upload_icon_circle">
                      <span>+</span>
                    </div>

                    <p>Upload here</p>
                  </div>
                </div>

                {/* TEXT */}
                {/* <div className="add_reviews_upload_text">
                  <h6>Upload your review video (optional)</h6>
                  <p>(Upload preferences: 10 Mb max)</p>
                </div> */}

                {/* BUTTON */}
                <div className="add_reviews_btn_holder">
                  <Dark_Gray_Btn
                    btnText="Submit"
                    className="add_reviews_submit_btn"
                    type="submit"
                    // onClick={() => {
                    //   setModalShow(true);
                    //   props.onHide();
                    // }}
                  />
                </div>
              </Form>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Logo_modal show={modalShow} onHide={() => setModalShow(false)} />
    </>
  );
}

export default Add_Reviews;
